import { ProjectType } from "@/consts/Project";
import { create } from "zustand";

interface EstimateInfo {
  projectId: string;
  projectType: ProjectType;
  originalId: string;
  itemSheetId: string;
}

interface ScenarioState {
  estimateInfo: EstimateInfo;
  setEstimateInfo: (info: Partial<EstimateInfo>) => void;
  selectedScenarioId: string | null;
  setSelectedScenarioId: (id: string | null) => void;
  confirmedScenarioId: string | null;
  setConfirmedScenarioId: (id: string | null) => void;
}

const useScenarioStore = create<ScenarioState>((set) => ({
  estimateInfo: {
    projectId: "",
    projectType: ProjectType.PROJ,
    originalId: "",
    itemSheetId: "",
  },
  selectedScenarioId: null,
  confirmedScenarioId: null,
  setEstimateInfo: (info) =>
    set((state) => ({
      estimateInfo: state.estimateInfo
        ? { ...state.estimateInfo, ...info }
        : (info as EstimateInfo),
    })),
  setSelectedScenarioId: (id: string | null) => set({ selectedScenarioId: id }),
  setConfirmedScenarioId: (id: string | null) =>
    set({ confirmedScenarioId: id }),
}));

export const useEstimateInfo = () =>
  useScenarioStore((state) => state.estimateInfo);

export const useSetEstimateInfo = () =>
  useScenarioStore((state) => state.setEstimateInfo);

export const useSelectedScenarioId = () =>
  useScenarioStore((state) => state.selectedScenarioId);

export const useSetSelectedScenarioId = () =>
  useScenarioStore((state) => state.setSelectedScenarioId);
